const map = {
	"./cs.json": 4540,
	"./da.json": 9593,
	"./de.json": 6477,
	"./en.json": 5553,
	"./es.json": 325,
	"./fr.json": 4554,
	"./it.json": 6851,
	"./nl.json": 6164,
	"./pl.json": 3638,
	"./pt.json": 4606,
	"./pt_BR.json": 9175,
	"./sk.json": 647,
	"./sv.json": 6643
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5931;